import React, { useState, useEffect } from "react";
import logoWeb from "../../assets/images/others/host-side-images/logo-web.png";
import { IoIosArrowDown } from "react-icons/io";
import { ReactComponent as UserIconNav } from "../../assets/images/svgs/nav-user-icon.svg";
import { ReactComponent as Notification } from "../../assets/images/svgs/notification-red.svg";
import { ReactComponent as NotificationOpen } from "../../assets/images/svgs/NotificationOpen.svg";
import NotificatinDrawer from "../drawers/host-side/NotificatinDrawer";
import { NavLink, useNavigate } from "react-router-dom";
import { siteRoutes } from "../../utils/helpers/enums/routes";

import dpIcon from "../../assets/images/others/host-side-images/dpIcon.png";
import AmbassadorNavbarDrawer from "components/drawers/ambassador-side/AmbassadorNavbarDrawer";
import useStore from "hooks/useStore";

const AmbassadorNavbar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [notificationDrawer, setNotificationDrawer] = useState<boolean>(false);
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const navigate = useNavigate();
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const { getUserProfilePic, getUserFullName } = useStore();
  const userProfilePic = getUserProfilePic();
  const userFullName = getUserFullName();

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const toggleNotificationDrawer = () => {
    setNotificationDrawer(!notificationDrawer);

    setIsNotificationOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* Navbar */}
      <nav
        className={`${
          isSticky
            ? "fixed top-0 left-0 w-full z-50 bg-white shadow-md transition-shadow duration-300 ease-in-out"
            : "bg-white transition-all duration-300 ease-in-out"
        } transition-transform ease-in-out`}
      >
        <div className="container flex justify-between items-center py-4">
          <div className="flex items-center">
            <img
              onClick={() => {
                navigate(siteRoutes.ambassadorHome);
              }}
              src={logoWeb}
              alt="logo"
              className="h-8 cursor-pointer"
            />
          </div>
          <div className="flex items-center gap-5 sm:gap-10">
            {/* Links */}
            <div className="hidden md:flex items-center gap-5 sm:gap-10 ">
              <NavLink
                to={siteRoutes.ambassadorCommunities}
                className={({ isActive }) =>
                  isActive ? "text-ambassadorBlue" : "text-darkBlueText"
                }
              >
                Community
              </NavLink>
              <NavLink
                to={siteRoutes.ambassadorWallet}
                className={({ isActive }) =>
                  isActive ? "text-ambassadorBlue" : "text-darkBlueText"
                }
              >
                Wallet
              </NavLink>
              <button
                onClick={toggleNotificationDrawer}
                className="text-blackie"
              >
                {isNotificationOpen ? <Notification /> : <NotificationOpen />}
              </button>
            </div>

            <button
              onClick={toggleDrawer}
              className="flex items-center gap-2 text-blackie"
            >
              <img
                className="w-8 h-8 rounded-full object-cover"
                src={userProfilePic}
                alt="dp"
              />
              {/* <UserIconNav /> */}
              <span className="hidden md:block text-primaryBlueText capitalize">
                {userFullName}
              </span>
              <IoIosArrowDown className="text-blackie" />
            </button>
          </div>
        </div>
      </nav>

      {/* Drawer Components */}
      {drawerOpen && (
        <AmbassadorNavbarDrawer isOpen={drawerOpen} onClose={toggleDrawer} />
      )}
      {notificationDrawer && (
        <NotificatinDrawer
          isOpen={notificationDrawer}
          onClose={toggleNotificationDrawer}
        />
      )}
    </div>
  );
};

export default AmbassadorNavbar;
